/**
 * 유효성 검증 유틸리티 함수
 */

import { IProjectFormData, ILoginFormData, IRegisterFormData } from '../@types';

/** 검증 결과 인터페이스 */
export interface ValidationResult {
    valid: boolean;
    message?: string;
}

/**
 * 프로젝트 폼 유효성 검증
 */
export function validateProjectForm(data: IProjectFormData): ValidationResult {
    if (!data.title?.trim()) {
        return { valid: false, message: '용역명을 입력해주세요.' };
    }
    if (!data.type) {
        return { valid: false, message: '점검종류를 선택해주세요.' };
    }
    if (data.type === '기타(직접입력)' && !data.type_etc?.trim()) {
        return { valid: false, message: '점검종류 내용을 입력해주세요.' };
    }
    if (!data.start_date || !data.end_date) {
        return { valid: false, message: '용역기간을 입력해주세요.' };
    }
    if (new Date(data.start_date) > new Date(data.end_date)) {
        return { valid: false, message: '착수일은 완료일보다 이전이어야 합니다.' };
    }
    if (!data.client?.trim()) {
        return { valid: false, message: '발주처를 입력해주세요.' };
    }
    return { valid: true };
}

/**
 * 로그인 폼 유효성 검증
 */
export function validateLoginForm(data: ILoginFormData): ValidationResult {
    if (!data.id?.trim()) {
        return { valid: false, message: '아이디를 입력해주세요.' };
    }
    if (!data.password) {
        return { valid: false, message: '비밀번호를 입력해주세요.' };
    }
    return { valid: true };
}

/**
 * 회원가입 폼 유효성 검증
 */
export function validateRegisterForm(data: IRegisterFormData): ValidationResult {
    if (!data.id?.trim()) {
        return { valid: false, message: '아이디를 입력해주세요.' };
    }
    if (!data.name?.trim()) {
        return { valid: false, message: '이름을 입력해주세요.' };
    }
    if (!data.email?.trim()) {
        return { valid: false, message: '이메일을 입력해주세요.' };
    }
    if (!isValidEmail(data.email)) {
        return { valid: false, message: '올바른 이메일 형식이 아닙니다.' };
    }
    if (!data.password) {
        return { valid: false, message: '비밀번호를 입력해주세요.' };
    }
    if (data.password.length < 8) {
        return { valid: false, message: '비밀번호는 8자 이상이어야 합니다.' };
    }
    if (data.password !== data.password_confirm) {
        return { valid: false, message: '비밀번호가 일치하지 않습니다.' };
    }
    return { valid: true };
}

/**
 * 이메일 형식 검증
 */
export function isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * 문자열 필수값 검증
 */
export function isRequired(value: string | undefined | null): boolean {
    return value !== undefined && value !== null && value.trim() !== '';
}
